import React, {FC} from "react"

import {H5, H6, Label} from "@irati/ui/src/Typography"
import Card from "@irati/ui/src/Layout/Card"
import mainTheme from "@irati/ui/src/global/theme"
import Flex from "@irati/ui/src/Flex"
import ProfilePicture from "@irati/ui/src/ProfilePicture"
import FormattedMessage from "@irati/utils/lang"
import {Team, CelebrationsReportPollWinner} from "@irati/types"

import ViewLink from "../../ViewLink"
import {FlexStartH6} from "../styled"
import {StyledCard} from "./styled"

interface Props {
  pollWinnerUser: CelebrationsReportPollWinner
  index: number
}

const RecognitionCard: FC<Props> = ({pollWinnerUser, index}) => {
  const firstTeam = pollWinnerUser?.user?.teams.results.find(
    (team: Team) => team.public_name !== "$$TEAM_ROOT$$" && !team.public_name.includes("platform.billingUnit")
  )?.public_name

  return (
    <StyledCard marginBottom={2} bgColor={mainTheme.colors.greys.lightest} padding={2}>
      <Flex marginBottom={1} alignItems="flex-start">
        <FlexStartH6 color={mainTheme.colors.primary1} marginRight={1}>
          {index + 1}
        </FlexStartH6>
        <ProfilePicture small user={pollWinnerUser.user} />
        <Flex marginLeft={1} direction="column">
          <>
            <H6>
              {pollWinnerUser?.user?.firstName} {pollWinnerUser?.user?.lastName}
            </H6>
            {firstTeam && <Label small>{firstTeam}</Label>}
            {pollWinnerUser?.regionName && <Label small>{pollWinnerUser?.regionName}</Label>}
          </>
        </Flex>
      </Flex>
      <Card padding={mainTheme.spacing.oneAndHalf}>
        <Label small marginBottom>
          <FormattedMessage id="admin.reporting.celebrations.pollWinnersCard.pollsWon.title" />
        </Label>
        <H5>{pollWinnerUser?.pollIds?.length}</H5>
        <Label small marginBottom>
          <FormattedMessage id="admin.reporting.celebrations.pollWinnersCard.votesReceived.title" />
        </Label>
        <H5>{pollWinnerUser.totalVotesReceived}</H5>
      </Card>
      <ViewLink text="admin.reporting.celebrations.pollWinnersCard.link" />
    </StyledCard>
  )
}

export default RecognitionCard
